import { CSSProperties, ReactNode } from 'react';
import { motion } from 'framer-motion';
import { RightOutline } from 'antd-mobile-icons';
import Avatar from '../Avatar';

interface ListItemProps {
  title: ReactNode;
  subtitle?: ReactNode;
  avatar?: string | null;
  avatarName?: string;
  avatarSize?: number | 'sm' | 'md' | 'lg' | 'xl';
  avatarColor?: 'blue' | 'orange' | 'green' | 'purple' | 'red';
  avatarStyle?: CSSProperties;
  icon?: ReactNode;
  iconColor?: string;
  iconBg?: string;
  right?: ReactNode;
  arrow?: boolean;
  onClick?: () => void;
  index?: number;
}

export default function ListItem({
  title,
  subtitle,
  avatar,
  avatarName,
  avatarSize = 'md',
  avatarColor = 'blue',
  avatarStyle,
  icon,
  iconColor = 'var(--color-on-primary)',
  iconBg = 'var(--color-primary)',
  right,
  arrow = false,
  onClick,
  index = 0
}: ListItemProps) {
  return (
    <motion.button
      type="button"
      className="ios-list-item"
      onClick={onClick}
      data-haptic={onClick ? 'selection' : undefined}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.18,
        delay: Math.min(index * 0.015, 0.1),
        ease: [0.25, 0.46, 0.45, 0.94]
      }}
      whileTap={{ scale: onClick ? 0.98 : 1, backgroundColor: 'var(--color-muted)' }}
      style={{ width: '100%', border: 0, cursor: onClick ? 'pointer' : 'default', textAlign: 'left' }}
      disabled={!onClick}
    >
      {avatar !== undefined ? (
        <Avatar
          src={avatar}
          name={avatarName || (typeof title === 'string' ? title : '')}
          size={avatarSize}
          color={avatarColor}
          style={{ marginRight: 12, ...avatarStyle }}
        />
      ) : icon ? (
        <div
          className="ios-list-item-icon"
          style={{ background: iconBg, color: iconColor, marginRight: 12 }}
        >
          {icon}
        </div>
      ) : null}

      <div className="ios-list-item-content">
        <div className="ios-list-item-title">{title}</div>
        {subtitle && <div className="ios-list-item-subtitle">{subtitle}</div>}
      </div>

      {right && <div style={{ marginRight: arrow ? 6 : 0 }}>{right}</div>}
      {arrow && <RightOutline className="ios-list-item-arrow" />}
    </motion.button>
  );
}
